import { HeaderComponent } from './header/header.component';

export const Components = [
	HeaderComponent,
];
